// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./js/components/ClassroomPanelList/classroomPanelList.scss
// module id = 864
// module chunks = 0